module.exports = __webpack_public_path__ + "img/mentalHealthBlack.37f8e7a0.svg";